import { datadogLogs } from '@datadog/browser-logs';
import env from '../env';

const { DD_CLIENT_TOKEN, DD_SITE, DD_ENV } = env;

function initLogger() {
  if (DD_ENV === 'qa04' || !(DD_CLIENT_TOKEN && DD_SITE && DD_ENV)) {
    return {
      error: (message: string, ctx: unknown, error?: unknown) => {
        // eslint-disable-next-line no-console
        console.error(message, ctx, error);
      },
    };
  }

  datadogLogs.init({
    clientToken: DD_CLIENT_TOKEN,
    site: DD_SITE,
    env: DD_ENV,
    forwardErrorsToLogs: false,
    sessionSampleRate: 100,
    service: 'charles',
  });
  datadogLogs.logger.setLevel('error');

  return {
    error: (message: string, ctx: unknown, error?: unknown) => {
      let parsedError: Error;
      if (error instanceof Error) {
        parsedError = error;
      } else {
        parsedError = new Error(String(error));
      }
      // eslint-disable-next-line no-console
      console.error(message, ctx, error);
      datadogLogs.logger.error(message, { ctx }, parsedError);
    },
  };
}

export default initLogger();
